
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 511 511"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M160 307.5h133.5c14.2 0 27.6-7.6 34.9-19.7l14.5-24.2a8 8 0 10-13.8-8.2l-14.5 24.2a24.7 24.7 0 01-21 11.9H160a8 8 0 000 16z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M504 323.6v-24.1c0-48.5-39.5-88-88-88h-44.2c-12.4-9.7-62.9-48-91.8-48h-54a108.5 108.5 0 00-33 5.2l-73.7 29.6c-11 3.5-22.6 5.2-34.1 5.2H58.7a8 8 0 00-1.5-2.2l-7.8-7.7A24 24 0 0064 171.5v-8a8 8 0 00-8-8H8a8 8 0 00-8 8v8a24 24 0 0024 24h4.7l8 8H30a22 22 0 00-22 22v66c0 18.5 13.3 34 33.9 39.7a56 56 0 0085.2 8.3H377a55.8 55.8 0 0078.2 0H503a8 8 0 001-16zM16 171.5h32a8 8 0 01-8 8H24a8 8 0 01-8-8zm340.3 48.3a42.5 42.5 0 00-8 7.3l-151-14.5c7-12.6 21.7-33.1 42.7-33.1h40c18.9 0 56.3 25.2 76.3 40.3zM24 291.5v-66a6 6 0 016-6h55.2a131.4 131.4 0 0039.8-6.2l73.4-29.6a117.6 117.6 0 00-20.9 32.9 8 8 0 006.7 10.9l167 16h.9c2.9 0 5.5-1.5 7-4.1.5-1 7.3-11.9 24.9-11.9h32a72 72 0 0172 72v24h-21.4a56 56 0 10-101.2 0H138.6a56 56 0 10-105.7-14.3 22.6 22.6 0 01-8.9-17.7zm24 8a40 40 0 1180 0 40 40 0 01-80 0zm368 40a40 40 0 110-80 40 40 0 010 80z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M112 291.5a8 8 0 00-8 8 16 16 0 11-16-16 8 8 0 000-16 32 32 0 1032 32 8 8 0 00-8-8zm328 0a8 8 0 00-8 8 16 16 0 11-16-16 8 8 0 000-16 32 32 0 1032 32 8 8 0 00-8-8z","fill":"currentColor"}})])
          )
        }
      }
    